export default (editor, { defaultModel, defaultView, ...config }) => {
  const type = 'slider-item'
  const attrKey = config.attrSliderItem
  const classKey = config.classSliderItem

  editor.DomComponents.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Slider Item',
        draggable: ':not(.slider)',
        droppable: ':not(.slider)',
        copyable: true,
        removable: true,
        'class-slide-active': config.classSlideActive,
        ...config.sliderItemProps
      },
      init() {
        const attrs = this.getAttributes()
        attrs[attrKey] = 1
        this.setAttributes(attrs)
        classKey && this.addClass(classKey)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrKey)) {
          return { type }
        }
      }
    }),
    view: defaultView.extend({
      init() {
        const comps = this.model.components()
        !comps.length && comps.add(config.templateItemContent)

      }
    })
  })
}
